module.exports = __webpack_public_path__ + "img/mail-sent.f53ef7fc.svg";